module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-SuperHeavy.94e548c.eot";